import React from 'react'
import {
  BooleanField,
  Datagrid,
  // TextField,
  // SearchInput,
  SelectInput,
  useTranslate,
  NumberField,
} from 'react-admin'
import {
  // Box,
  // CardContent,
  // Grid,
  // Typography,
  // TypographyProps,
  styled,
  // Stack,
  // Paper,
} from '@mui/material'
import { ListBase } from '../../components/base'
import { DateField, ImageField } from '../../components/fields'
import { COMMON_FIELDS, PARTNER_ICONS_FIELDS } from '../../providers/localization/constant'

const PreviewImage = styled(ImageField)(() => ({
  '& .RaImageField-image': {
    width: 168,
    height: 168,
    objectFit: 'contain',
    borderRadius: 5,
  },
}))

const PartnerIconsListFilters = (): JSX.Element[] => {
  // const translate = useTranslate()
  return [
    // <SearchInput
    //   key={0}
    //   source='q'
    //   alwaysOn
    //   InputLabelProps={{ shrink: true }}
    //   InputProps={{ notched: false }}
    //   placeholder={translate(`${PARTNER_ICONS_FIELDS}.name`)}
    // />,
    <SelectInput
      key={1}
      label={`${COMMON_FIELDS}.status.label`}
      source='is_active'
      choices={[
        { id: 'true', name: `${COMMON_FIELDS}.status.choices.active` },
        { id: 'false', name: `${COMMON_FIELDS}.status.choices.inActive` },
      ]}
    />,
  ]
}

const PartnerIconsList = (): JSX.Element => {
  const translate = useTranslate()
  return (
    <ListBase
      listAction={{
        hasExport: false,
      }}
      filters={PartnerIconsListFilters()}
      sort={{ field: 'create_at', order: 'DESC' }}
    >
      <Datagrid rowClick='edit'>
        {/* <TextField source='title_th' label={`${PARTNER_ICONS_FIELDS}.title_th`}></TextField> */}
        <NumberField source='order' label={`${COMMON_FIELDS}.order`} />
        <PreviewImage
          label={translate(`${PARTNER_ICONS_FIELDS}.icon`)}
          source='icon.full_path'
          sortable={false}
        />
        <DateField
          source='create_at'
          label={`${COMMON_FIELDS}.date.created_at`}
          textAlign='center'
        />
        <DateField
          source='update_at'
          label={`${COMMON_FIELDS}.date.updated_at`}
          textAlign='center'
        />
        <BooleanField
          source='is_active'
          label={`${COMMON_FIELDS}.status.label`}
          textAlign='center'
          sortable={false}
        />
      </Datagrid>
    </ListBase>
  )
}

export default PartnerIconsList
